import React from "react";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import LinearProgress from "@material-ui/core/LinearProgress";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import EuroIcon from "@material-ui/icons/Euro";
import * as Glob from "../../Globale";
import { Trad } from "../../components";
import { _NumberFormat } from ".";

export type TNumberFieldProps = TextFieldProps & {
    Value: string | number;
    OnChange: (e: string, val: string) => void;
    Label: string;
    Id: string;
    Adornment?: React.ReactNode;
    Disabled?: boolean;
    Min?: number;
    Max?: number;
    ProgressBar?: boolean;
    NeutralVal?: number;
    OnChangeDerogation?: (e: React.FormEvent<any>) => void;
};

export const _NumberField: React.FC<TNumberFieldProps> = ({
    Adornment,
    Disabled,
    Id,
    Label,
    OnChange,
    Value,
    InputProps,
    Min = -9999999999999.99,
    Max = 9999999999999.99,
    NeutralVal,
    ProgressBar,
    OnChangeDerogation,
    ...rest
}) => {
    const onValueChange = (e: React.FormEvent<any>) => {
        const val = Number(e.currentTarget.value);

        if ((val >= Min && val <= Max) || (NeutralVal != undefined && val == NeutralVal)) {
            OnChange(e.currentTarget.id, e.currentTarget.value);
        }
    };
    rest.value = Value;
    return (
        <>
            {OnChangeDerogation && <FormControlLabel control={<Checkbox onChange={OnChangeDerogation} name={Id} />} label={Trad.Trad(Label)} />}
            
            <TextField
                id={Id}
                label={OnChangeDerogation ? "" : Trad.Trad(Label)}
                onChange={onValueChange}
                disabled={Disabled}
                InputProps={{
                    endAdornment: <InputAdornment position="end">{Adornment}</InputAdornment>,
                    inputComponent: _NumberFormat as any,
                    ...InputProps
                }}
                inputProps={{ className: "numberInput" }}
                fullWidth
                {...rest}
            />
            {ProgressBar && (
                <Box mt="2px">
                    <LinearProgress variant="determinate" value={(Number(rest.value) / Max) * 100} color="secondary" />
                    <Box display="flex" alignContent="space-between">
                        <Box flexGrow="1">
                            <Typography variant="caption">{Glob.FormatNumber(Min)}</Typography>
                        </Box>
                        <Box>
                            <Typography variant="caption">{Glob.FormatNumber(Max)}</Typography>
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};

_NumberField.defaultProps = {
    Adornment: <EuroIcon fontSize="small" color="action" />
};



// WEBPACK FOOTER //
// ./src/inar2/form/NumberField.tsx